<div class="vehicle-detail-container">
  <div class="row description-row">
    <div class="description header">VRM</div>
    <div class="description value">
      {{ vrm | uppercase }}
    </div>
    <div class="w-100"></div>
  </div>
  <div class="d-flex flex-row flex-wrap-mobile">
    <div class="w-100">
      <div class="row description description-row">
        <div class="description header">Make</div>
        <div class="w-100"></div>
        <div class="description value">
          {{ vehicleDescription.Manufacturer }}
        </div>
      </div>
      <div class="row description-row">
        <div class="description header">Model</div>
        <div class="w-100"></div>
        <div class="description value extended">
          {{ vehicleDescription.Model }}
        </div>
      </div>
      <div class="row description-row" *ngIf="isQQDetails">
        <div class="description header">CAP ID</div>
        <div class="w-100"></div>
        <div class="description value salvage">{{ capData }}</div>
      </div>
    </div>
    <div class="vertical-line"></div>
    <div class="w-100">
      <div class="row description description-row">
        <div class="description header">Colour</div>
        <div class="w-100"></div>
        <div class="description value">
          {{ vehicleDescription.Colour }}
        </div>
      </div>
      <div class="row description-row">
        <div class="description header">Engine</div>
        <div class="w-100"></div>
        <div class="description value extended">
          {{ engineFormat }}
        </div>
      </div>
      <div class="row description-row" *ngIf="isQQDetails">
        <div class="description header">Vcheck</div>
        <div class="w-100"></div>
        <div class="description value salvage-desc">
          {{ salvageWarning }}
        </div>
      </div>
    </div>
  </div>
  <div class="row description-row" *ngIf="!isQQDetails">
    <div class="description header">CAP ID</div>
    <div class="description value">
      {{ capData }}
    </div>
    <div class="w-100"></div>
  </div>
</div>